import TriviaQuestion from "components/TriviaGames/TriviaQuestion";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import WellnessService from "services/WellnessService";
import NoDataImg from "../../assets/img/no-data-found.jpg";
import { useTeamContext } from "store/contexts/teamContext";
import { useHistory } from "react-router-dom";
import Loader from "components/Loader";
import CustomButton from "components/CustomButton";
import { useUserContext } from "store/contexts/userContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const styles = {
  container: {
    border: "1px solid #e9e9e9",
    borderRadius: "10px",
  },
  btnDiv: {
    display: "flex",
    margin: "10px 0px 10px 0px",
    justifyContent: "flex-end",
  },
  webhookOption: {
    position: "relative",
    height: "50px",
    border: "1px solid #43434317",
    borderRadius: "6px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: 400,
    justifyContent: "space-between",
    cursor: "pointer",
    minWidth: "300px",
  },
  webhookContent: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "20px",
    fontWeight: "bold",
  },
  optionName: {
    padding: "5px 10px",
    borderBottom: "1px solid #dee2e6",
  },
  note: {
    fontSize: "10px",
    marginBottom: "5px",
    textAlign: "right",
    letterSpacing: "1px",
  },
};
export default () => {
  const classes = styles;
  const navigation = useHistory();
  const { team } = useTeamContext();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [triviaId, setTriviaId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [allRequired, setAllRequired] = useState(false);
  const [reload, setReload] = useState(false);
  const { user } = useUserContext();

  useEffect(() => {
    setLoading(true);
    WellnessService.getActiveTrivia(team?.id, user.id)
      .then((res) => {
        setQuestions(res?.data || []);
        setTriviaId(res?.data ? res?.data[0]?.trivia_id : "");
        setLoading(false);
      })
      .catch(() => {
        setQuestions([]);
        setTriviaId("");
        setLoading(false);
      });
  }, [team.id, reload, user.id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center">
        <Loader />
      </div>
    );
  }

  const handleSubmit = (data) => {
    setSubmitting(true);
    setAllRequired(false);
    const answers = Object.entries(data).map((k) => ({
      question_id: k[0],
      answer_id: k[1],
    }));

    if (answers.length === questions.length) {
      const payload = {
        teamId: team.id,
        triviaId,
        answers,
      };
      WellnessService.answerTrivia(payload)
        .then(() => {
          setSubmitting(false);
          setReload(!reload);
        })
        .catch(() => setSubmitting(false));
    } else {
      setSubmitting(false);
      setAllRequired(true);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{ marginRight: "15px", cursor: "pointer" }}
            onClick={() =>
              navigation.push(`/teams/${team?.id}/wellness/focus-boosters`)
            }
          />
          <h5 style={{ margin: "0px" }}>Trivia</h5>
        </div>
        {(team?.role_id === 2 || team?.role_id === 3) && (
          <div style={classes.btnDiv}>
            <CustomButton
              onClick={() =>
                navigation.push(
                  `/teams/${team?.id}/wellness/focus-boosters/trivia/manage`
                )
              }
            >
              Manage Trivia
            </CustomButton>
          </div>
        )}
      </div>
      {!loading && questions.length === 0 && (
        <div className="d-flex justify-content-center flex-column align-items-center">
          <img alt="" src={NoDataImg} width={"70%"} />
          <div>
            No worries, you will get trivia questions when managment will
            initiate
          </div>
        </div>
      )}
      {questions.length > 0 && (
        <div className="mt-2">
          <Formik
            initialValues={{}}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                handleSubmit(values);
                actions.setSubmitting(false);
              }, 1000);
            }}
          >
            {(props) => (
              <form onSubmit={props.handleSubmit}>
                <div style={classes.note}>
                  Response will not be auto saved, you need to submit your
                  answers.
                </div>
                {allRequired && (
                  <p className="text-danger">All questions is required.</p>
                )}
                <div style={classes.container}>
                  {questions.map((que, iDx) => (
                    <TriviaQuestion
                      value={props.values[que.id]}
                      form={props}
                      data={que}
                      isLast={questions.length === iDx + 1}
                      setAllRequired={setAllRequired}
                    />
                  ))}
                </div>
                <div style={classes.btnDiv}>
                  <button
                    className="btn btn-warning"
                    type="submit"
                    disabled={submitting}
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};
